(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqNavigation = document.getElementById('faq-navigation');
    const faqTitles = document.querySelectorAll('.faq-title');

    // Add the title to the navigation and link to the title
    faqTitles.forEach((title) => {
      const id = title.id.split('-')[2];
      const li = document.createElement('li');
      li.innerHTML = `<a href="#faq-title-${id}">${title.textContent}</a>`;
      faqNavigation.appendChild(li);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (evt) => {
    if (evt.target.matches('.swiper-slide')) {
      const swiperContainer = evt.target.closest('.swiperHeroSlider');
      const swiperInstance = swiperContainer?.swiper;
      if (!swiperInstance) return;

      swiperInstance.init();

      setTimeout(() => {
        swiperInstance.slideTo(Number(evt.target.dataset.swiperSlideIndex));
        if (swiperInstance.autoplay) {
          swiperInstance.stop();
        }
      }, 200);
    }
  });

  document.addEventListener('shopify:block:deselect', (evt) => {
    if (evt.target.matches('.swiper-slide')) {
      const swiperContainer = evt.target.closest('.swiperHeroSlider');
      const swiperInstance = swiperContainer?.swiper;
      if (!swiperInstance) return;

      swiperInstance.init();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
